import styled from 'styled-components/macro';

export const Container = styled.div`
  position: relative;
  box-sizing: border-box;
  padding: 22px 50px 22px 0;

  transition: background-color 0.2s, opacity 0.2s;

  &::before {
    content: '';
    width: 100%;
    height: 2px;
    background-color: ${({ theme }) => theme.colors.border};
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export const Details = styled.div`
  width: 66%;
  display: inline-block;
  vertical-align: middle;
`;

export const Title = styled.p`
  color: ${({ theme }) => theme.colors.text};
  margin: 0 0 8px;
  font-size: 1rem;
  line-height: 1.35;
`;

export const Desc = styled.p`
  color: ${({ theme }) => theme.colors.muted};
  margin: 0;
  line-height: 1.35;
`;

export const Price = styled.div`
  display: inline-block;
  vertical-align: middle;
  color: ${({ theme }) => theme.colors.secondary};
  text-align: right;
  width: 34%;

  p {
    margin: 0 0 14px;
    font-weight: 700;
  }
`;

export const DeleteButton = styled.button`
  width: 30px;
  height: 30px;
  top: 20px;
  right: 0;
  border-radius: 50%;
  position: absolute;
  z-index: 2;
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.colors.border};
  background-color: #fff;
  color: ${({ theme }) => theme.colors.primary};
  line-height: 26px;
  text-align: center;
  font-size: 1rem;

  &:focus-visible {
    outline: 3px solid ${({ theme }) => theme.colors.secondary};
    outline-offset: 2px;
  }

  &:hover {
    color: #fff;
    background-color: ${({ theme }) => theme.colors.secondary};
    border-color: ${({ theme }) => theme.colors.secondary};
  }
`;

export const ChangeQuantity = styled.button`
  color: ${({ theme }) => theme.colors.primary};
  border: 1px solid ${({ theme }) => theme.colors.border};
  background-color: ${({ theme }) => theme.colors.accent};
  width: 34px;
  height: 32px;
  cursor: pointer;

  &:focus-visible {
    outline: 3px solid ${({ theme }) => theme.colors.secondary};
    outline-offset: 2px;
  }

  &:hover:not(:disabled) {
    color: #fff;
    background-color: ${({ theme }) => theme.colors.secondary};
    border-color: ${({ theme }) => theme.colors.secondary};
  }

  &:disabled {
    opacity: 0.2;
    cursor: not-allowed;
  }
`;
